import { consumptionMetricIds } from '@/components/Workflow/Show/Views/Consumption/Consumption.utils';
import { PresetCalculation } from '@/model/PresetCalculation.model';

export const generateMeasurementOptions = (
  calculations: Array<PresetCalculation> = []
): Array<{ label: string; value: string }> => {
  return (calculations ?? []).reduce<Array<{ label: string; value: string }>>(
    (acc, { name, id }: PresetCalculation) => {
      if (!consumptionMetricIds.has(id)) {
        acc.push({ label: name, value: id });
      }
      return acc;
    },
    []
  );
};
